import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyConfig } from '@lockton-apps/shared/interfaces';

@Pipe({
    name: 'currency2',
    standalone: false
})
export class Currency2Pipe implements PipeTransform {
  transform(
    value: string | number | null | undefined,
    options?: CurrencyConfig
  ): unknown {
    return this.currencyPipe.transform(
      value,
      options?.currencyCode,
      options?.display,
      options?.digitsInfo,
      options?.locale
    );
  }

  constructor(private currencyPipe: CurrencyPipe) {}
}
